module.exports = __webpack_public_path__ + "static/media/apng_marin.024a7015.png";